import routerOptions0 from "/home/wann/Development/vuenuxt/ordinator/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/wann/Development/vuenuxt/ordinator/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}